var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterFunnel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.82516 4.72239C2.19487 4.01796 1.87973 3.66574 1.86785 3.3664C1.85752 3.10636 1.96927 2.85643 2.16994 2.69074C2.40095 2.5 2.87357 2.5 3.81881 2.5H16.1879C17.1332 2.5 17.6058 2.5 17.8368 2.69074C18.0375 2.85643 18.1492 3.10636 18.1389 3.3664C18.127 3.66574 17.8119 4.01796 17.1816 4.72239L12.4264 10.037C12.3007 10.1774 12.2379 10.2477 12.1931 10.3276C12.1534 10.3984 12.1242 10.4747 12.1066 10.554C12.0867 10.6435 12.0867 10.7377 12.0867 10.9261V15.382C12.0867 15.5449 12.0867 15.6264 12.0604 15.6969C12.0372 15.7591 11.9994 15.8149 11.9502 15.8596C11.8946 15.9102 11.8189 15.9404 11.6676 16.001L8.8343 17.1343C8.52801 17.2568 8.37487 17.3181 8.25193 17.2925C8.14442 17.2702 8.05008 17.2063 7.98941 17.1148C7.92004 17.0101 7.92004 16.8452 7.92004 16.5153V10.9261C7.92004 10.7377 7.92004 10.6435 7.90014 10.554C7.88249 10.4747 7.85334 10.3984 7.81361 10.3276C7.76882 10.2477 7.706 10.1774 7.58036 10.037L2.82516 4.72239Z",
    stroke: "#344054",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterFunnel);
export default __webpack_public_path__ + "static/media/filter-funnel.9aae16c8807d72cd70a85fa5dfdfe346.svg";
export { ForwardRef as ReactComponent };